import React, { useEffect, useState } from 'react';
import {
  ProductsPage,
  PageHeader,
  PageTitle,
  AddProductButton,
  ProductsStats,
  StatItem,
  StatNumber,
  StatLabel
} from '../../styles/ProductsStyles';
import { AddButton, Dropdown, Field, HeadersModal, Input, Item, Label, ListActionButton, ListActions, ListCategory, ListInfo, ListItem, ListName, ModalContent, ModalOverlay, ProductsList, TableRowProduct } from '../../styles/common';
import { useNavigate } from "react-router-dom";
import { CreateCategories, DeleteBanners, DeleteCategory, GetBanners, GetBrands, GetCategories, GetSubCategories, UpdateBannersStatus } from '../../common/CommonApi';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import { Radio } from 'lucide-react';
import { useSelector } from 'react-redux';


const PageContainer = styled.div`
  padding: 30px;
  background: #f9fafb;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 0;
    min-height: auto;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
`;

const BannerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const BannerCard = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: translateY(-4px);
  }
`;

const BannerImage = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
`;

const BannerContent = styled.div`
  padding: 15px;
  display:flex;
  gap:10px;
  flex-wrap: wrap;
`;

const BannerTitle = styled.h2`
  font-size: 18px;
  color: #222;
  margin-bottom: 10px;
  text-align:center;
`;

const Status = styled.button`
  padding: 6px 12px;
  border-radius: 10px;
  font-size: 14px;
  // font-weight: 500;
  border:none;
  width:100px;
  cursor:pointer;
  color: ${(props) => (props.active ? "#0f5132" : "#842029")};
  background: ${(props) => (props.active ? "#d1e7dd" : "#f8d7da")};
`;

const RedirectButton = styled.a`
  display: inline-block;
  text-decoration: none;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  background: #2563eb;
  color: white;
  transition: background 0.2s;

  &:hover {
    background: #1e40af;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 0;
`;

const RadioItem = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
`;

const RadioInput = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
`;

const Banner = () => {
  const [editCat, setEditCat] = useState(false);
  const [editId, setEditId] = useState('');
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [categoriesItem, setCategoriesItem] = useState('');
  const [subcategoriesItem, setSubCategoriesItem] = useState('');
  const [brandsId, setBrandsId] = useState('');
  const [brands, setBrands] = useState([]);
  const [bannerType, setBannerType] = useState('');
  const userProfile = useSelector((state) => state.auth);
  // Sample banner array with images
  const [banners, setBanners] = useState([])
  useEffect(() => {
    GetBannersFun()
  }, [])
  const GetBannersFun = async () => {
    let data = await GetBanners()
    setBanners(data?.data?.data)
  }

  const [addCategory, setAddCategory] = useState(false);
  const [form, setForm] = useState({
    bannerTitle: '',
    redirect: 'product_by_category',
    status: false,
    shorting: 0,
    layout:'normal',
    bannerImage: null,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files , layout} = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
            ? files[0]   // 👈 will store in form.categoryImage
            : name === "sortOrder"
              ? Number(value)
              : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("bannerTitle", form.bannerTitle);
    formData.append("redirect", form.redirect);
    formData.append("status", form.status);
    formData.append("shorting", form.shorting);
    formData.append("category", categoriesItem);
    formData.append("subcategory", subcategoriesItem);
    formData.append("brandsId", brandsId);
    formData.append("layout", form.layout);

    if (form.bannerImage) {
      formData.append("bannerImage", form.bannerImage);
    }
    try {
      if (editCat) {
        const response = await fetch(`${process.env.REACT_APP_API_URL}categories/${editId}`, {
          method: "PUT",
          body: formData,
        });
        const data = await response.json();
        if (data.message == "SUCCESSFULLY_UPDATED") {
          Swal.fire('Banner Added.')
          setAddCategory(false)
        }
        // console.log("Success:", data);

      } else {
        const response = await fetch(process.env.REACT_APP_API_URL + "banners", {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (data.message == "SUCCESS_FULLY_CREATED") {
          Swal.fire('Banners Added.')
          setAddCategory(false)
        }
        console.log("Success:", data);
      }

      // const response = await CreateCategories(formData)


    } catch (err) {
      console.error("Error:", err);
    }
  };

  const deleteCategory = async (id) => {
    await DeleteCategory(id)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const categoriesResponse = await GetCategories();
    let brands = await GetBrands(userProfile?._id)
    console.log("--->brands",brands)
    if (brands.data.message == 'brands retrieved successfully') {
      setBrands(brands?.data?.data)
      setBrandsId(brands?.data?.data[0]?._id)
    }
    setCategories(categoriesResponse?.data?.data);
    getSubCategory(categoriesResponse?.data?.data[0]?._id)
    setCategoriesItem(categoriesResponse?.data?.data[0]?._id)
  }

  const handleProduct = (e) => {
    if (e.target.name != 'subcategories') {
      getSubCategory(e.target.value)
      setCategoriesItem(e.target.value)
    }
    setSubCategoriesItem(e.target.value)
  }

  const handleBrands = (e) => {
    setBrandsId(e.target.value)
  }

  const handleBannerStatusChange = async (e, banner) => {
    e.stopPropagation();
    const updatedStatus = !banner.status;
    let resp = await UpdateBannersStatus(banner._id, { status: updatedStatus })
    if (resp?.data?.message === "SUCCESSFULLY_UPDATED") {
      Swal.fire("Status Updated")
      GetBannersFun()
    }
  }


  const handleDeleteBanner = (e, banner) => {
    Swal.fire({
      title: 'Do you want to delete the Banners?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Swal.fire('Saved!', '', 'success')
        await DeleteBanners(banner._id)
        GetBannersFun()
      }
    })
  }

  const getSubCategory = async (id) => {
    let data = await GetSubCategories(id);
    setSubCategoriesItem(data?.data?.data[0]?._id)
    setSubCategories(data?.data?.data)
  }


  return (
    <ProductsPage>
      <PageHeader>
        <PageTitle>Banners Management</PageTitle>
        <AddProductButton onClick={() => {
          setAddCategory(true)
          setEditCat(false)
        }}>+ Add New Product</AddProductButton>
      </PageHeader>
      <ProductsList>
        <PageContainer>
          <BannerGrid>
            {banners.map((banner) => (
              <BannerCard key={banner.id}>
                <BannerImage src={banner.bannerImage} alt={banner.bannerTitle} />
                <BannerTitle>{banner.bannerTitle}</BannerTitle>
                <BannerContent>
                  <Status active={banner.status === true} onClick={(e) => handleBannerStatusChange(e, banner)}>
                    {banner.status === true ? 'Active' : 'Deactive'}
                  </Status>
                  <RedirectButton href={banner.redirect} target="_blank" rel="noopener noreferrer">
                    Redirect
                  </RedirectButton>
                  <Status active={false} onClick={(e) => handleDeleteBanner(e, banner)}>
                    Delete
                  </Status>
                </BannerContent>
              </BannerCard>
            ))}
          </BannerGrid>
        </PageContainer>
      </ProductsList>
      {
        addCategory &&
        <ModalOverlay>
          <ModalContent>
            <HeadersModal>
              <h2>Add Banner</h2>
              <img onClick={() => setAddCategory(false)} style={{ width: "18px" }} src='https://app.ootfit.com/assets/close.png' />
            </HeadersModal>

            <Field>
              <Label>Banner Name</Label>
              <Input name="bannerTitle"
                value={form.bannerTitle} onChange={handleChange}
              />
            </Field>
            <Field>
              <RadioGroup>
                <RadioItem htmlFor="Brands">
                  <RadioInput
                    type="radio"
                    name="Brands"
                    id="Brands"
                    value="Brands"
                    checked={bannerType === "Brands"}
                    onChange={() => setBannerType("Brands")}
                  />
                  Brands
                </RadioItem>

                <RadioItem htmlFor="Categories">
                  <RadioInput
                    type="radio"
                    name="Categories"
                    id="Categories"
                    value="Categories"
                    checked={bannerType === "Categories"}
                    onChange={() => setBannerType("Categories")}
                  />
                  Categories
                </RadioItem>
              </RadioGroup>
            </Field>
            {
              bannerType == 'Categories' &&
            <TableRowProduct cols={2} style={{ background: "none", padding: "0px", border: "none" }}>
              <Field>
                <Label>Main Category</Label>
                <Dropdown
                  name="category"
                  onChange={handleProduct}
                >
                  {
                    categories.map((data) => {
                      return (<Item value={data._id}>{data.categoryName}</Item>)
                    })
                  }
                </Dropdown>
              </Field>
              {
                categoriesItem &&
                <Field>
                  <Label>Sub Category</Label>
                  <Dropdown
                    name="subcategories"
                    onChange={handleProduct}
                  >
                    {
                      subcategories.map((data) => {
                        return (<Item value={data._id}>{data.subcategoryName}</Item>)
                      })
                    }
                  </Dropdown>
                </Field>
              }
            </TableRowProduct>
            }
            {bannerType == 'Brands' && 
              <Field>
              <Label>Brands</Label>
              <Dropdown
                name="Brands"
                onChange={handleBrands}
              >
                {
                  brands.map((data) => {
                    return (<Item value={data._id}>{data.brandName}</Item>)
                  })
                }
              </Dropdown>
            </Field>
            }
            <Field>
              <Label>Status</Label>
              <Dropdown
                value={form.status}
                name="status"
                onChange={handleChange}
              >
                <Item value="yes">Yes</Item>
                <Item value="no">No</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Redirect to Page</Label>
              <Dropdown
                name="redirect"
                value={form.redirect} onChange={handleChange}
              >
                <Item value="product_by_category">Product by Category</Item>
                <Item value="product_by_subcategory">Product by SubCategory</Item>
                <Item value="product_by_brands">Product by Brands</Item>
                <Item value="none">None</Item>
              </Dropdown>
            </Field>
            {/* <Field>
              <Label>Redirect to Page</Label>
              <Input name="redirect"
                value={form.redirect} onChange={handleChange}
              />
            </Field> */}
            <Field>
              <Label>Sort Order</Label>
              <Dropdown
                name="shorting"
                value={form.shorting}
                onChange={handleChange}
              >
                <Item value="1">1</Item>
                <Item value="2">2</Item>
                <Item value="3">3</Item>
                <Item value="4">4</Item>
                <Item value="5">5</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Layout</Label>
              <Dropdown
                name="layout"
                value={form.layout}
                onChange={handleChange}
              >
                <Item value="strip">Strip Layout</Item>
                <Item value="fixed_strip">Fixed Strip Layout</Item>
                <Item value="normal">Normal Layout</Item>
                <Item value="fixed_layout">Fixed Layout</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Banner Image</Label>
              <Input
                type='file'
                name="bannerImage"
                accept="image/*"
                onChange={handleChange}
              />
            </Field>
            <AddButton onClick={handleSubmit}>{editCat ? 'Edit' : 'Add'}</AddButton>
          </ModalContent>
        </ModalOverlay>
      }
    </ProductsPage>
  );
};

export default Banner;
